import {createStore} from "ui.vue3.vuex"
import {BitrixVue} from "ui.vue3"
import {Form} from "./components/form"

export class Auth {
    constructor(rootNode, data) {
        this.rootNode = document.querySelector(rootNode);
        this.data = data
    }

    start() {
        let context = this,
            store = createStore({
                state() {
                    return context.data
                },
                mutations: {
                    setMode(state, value) {
                        state.mode = value
                        state.email = ''
                        state.phone = ''
                    },
                    setPhone(state, value) {
                        state.phone = value
                        if (value) {
                            state.errors = {...state.errors, phone: false}
                        }
                    },
                    setEmail(state, value) {
                        state.email = value
                        if (value) {
                            state.errors = {...state.errors, email: false}
                        }
                    },
                    setStep(state, value) {
                        state.step = value
                        state.code = ''
                        if (state.errors.code) {
                            state.errors = {...state.errors, code: false}
                        }
                        if (value === 'code') {
                            state.timer = 60
                            let interval = setInterval(function () {
                                if (state.timer > 0)
                                    state.timer = state.timer - 1
                                else
                                    clearInterval(interval)
                            }, 1000)
                        }

                        // Блок "Или используйте Telegram" рисуется вне корня, куда монтируется Vue
                        // (виджету нужен стабильный DOM-узел вне in-DOM-компиляции — см. template.php),
                        // поэтому Vue его не видит и v-if тут не поможет; переключаем напрямую при
                        // смене шага. На шаге ввода кода блок скрыт: это альтернативный способ входа,
                        // а не что-то к уже отправленному коду.
                        let socialBlock = context.rootNode.parentElement
                            && context.rootNode.parentElement.querySelector('.popups-social')
                        if (socialBlock) {
                            socialBlock.style.display = value === 'initial' ? 'flex' : 'none'
                        }
                    },
                    setCode(state, value) {
                        state.code = value
                        if (state.errors.code) {
                            state.errors = {...state.errors, code: false}
                        }
                    },
                    setLoading(state, value) {
                        state.loading = value
                    },
                    setErrors(state, value) {
                        state.errors = value
                    }
                }
            }),
            application = BitrixVue.createApp({
                name: 'AuthForm',
                components: {Form},
                beforeCreate() {
                    this.$bitrix.Application.set(context);
                },
                template: '<Form/>'
            })

        application.use(store)
        application.mount(this.rootNode)
    }
}
